export const CALL_LINK = "https://calendly.com/mostafa-abdelaziz-jii/30min";
export const PRIVACY_POLICY = '/privacy-policy'
export const COOKIE_POLICY = '/cookie-policy'
